"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.feedbackData = void 0;
var _ReduxConstant = _interopRequireDefault(require("../../config/ReduxConstant"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var INITIAL_STATE = [];
var feedbackData = exports.feedbackData = function feedbackData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _ReduxConstant["default"].SET_FEEDBACK_DATA:
      return action.payload || [];
    default:
      return state;
  }
};